import React, { useCallback, useState } from 'react'
import { CCard, CCardBody } from '@coreui/react-pro'
import { useLocation } from 'react-router-dom'
import Table from './Table'
import LoginMember from './LoginMember'
import ManageMember from './ManageMember'
import './User.css'

const MEMBERS = 'members'
const ONLINE = 'online'
const MANAGE = 'manage'

const TABS = [
  { key: MEMBERS, label: 'Members List' },
  { key: ONLINE, label: 'Online Members' },
  { key: MANAGE, label: 'Manage Members' },
]

// /manage-members is still its own nav item, so land that route on the matching tab.
const TABS_BY_PATH = { '/manage-members': MANAGE }

const User = () => {
  const { pathname } = useLocation()
  const [activeTab, setActiveTab] = useState(TABS_BY_PATH[pathname] || MEMBERS)
  // All three tables stay mounted so each tab's count is known before it is opened, and so
  // switching tabs keeps the paging/search the admin had set.
  const [totals, setTotals] = useState({ [MEMBERS]: null, [ONLINE]: null, [MANAGE]: null })

  // Stable per-tab reporters: the tables keep these in their fetch dependencies, so a new
  // function identity on every render would make each table re-fetch after every count update.
  const setTotal = useCallback(
    (key, total) =>
      setTotals((current) => (current[key] === total ? current : { ...current, [key]: total })),
    [],
  )
  const setMembersTotal = useCallback((total) => setTotal(MEMBERS, total), [setTotal])
  const setOnlineTotal = useCallback((total) => setTotal(ONLINE, total), [setTotal])
  const setManageTotal = useCallback((total) => setTotal(MANAGE, total), [setTotal])

  return (
    <>
      <div className="ge-page-header">
        <h1 className="ge-page-title">Members</h1>
        <p className="ge-page-subtitle">
          Manage the members of this game and see who is online right now.
        </p>
      </div>

      <div className="ge-tabs" role="tablist">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.key}
            className={`ge-tab${activeTab === tab.key ? ' active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
            {totals[tab.key] !== null && <span className="ge-tab-count">{totals[tab.key]}</span>}
          </button>
        ))}
      </div>

      <CCard className="um-panel">
        <CCardBody>
          <div className={activeTab === MEMBERS ? undefined : 'd-none'}>
            <Table onTotalChange={setMembersTotal} />
          </div>
          <div className={activeTab === ONLINE ? undefined : 'd-none'}>
            <LoginMember onTotalChange={setOnlineTotal} />
          </div>
          <div className={activeTab === MANAGE ? undefined : 'd-none'}>
            <ManageMember onTotalChange={setManageTotal} />
          </div>
        </CCardBody>
      </CCard>
    </>
  )
}

export default User
